import { createFileRoute } from '@tanstack/react-router'
import { EventsPage } from '@/pages/events/EventsPage'

export const Route = createFileRoute('/_private/events/')({
    component: EventsPage,
})
